<template>
  <div class="order-print-table" v-show='false'>
    <el-table
      id="out-table"
      :data="orderTableData"
      style="width: 100%"
      border
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
      >
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="推送日期"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="out_ware_day"
        label="要求发货日"
      >
      </el-table-column>
      <el-table-column
        prop="main_number"
        label="主订单号"
        width="110"
      >
      </el-table-column>
      <el-table-column
        prop="total_price"
        label="订单总金额"
        width="110"
      >
      </el-table-column>
      <el-table-column
        prop="total_amount"
        label="订购总量"
        width="135"
      >
      </el-table-column>
      <el-table-column
        prop="total_send_amount"
        label="实发总量"
        width="135"
      >
      </el-table-column>
      <el-table-column
        prop="box_num"
        label="打包箱数"
        width="300"
      >
      </el-table-column>
      <el-table-column
        prop="weight"
        label="总称重(kg)"
      >
      </el-table-column>
      <el-table-column
        prop="od_statusName"
        label="状态"
      >
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="客户"
      >
      </el-table-column>
      <el-table-column
        prop="print_num"
        label="已打印次数"
      >
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ['orderTableData'],
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/order-print-table.vue